import { SortOrder } from 'kentico-cloud-delivery';
import Client from '../services/kenticoClient';
import { KENTICO_TYPES } from 'common/consts/kentico';

export const PRESS_ARTICLES_LIMIT = 14;

class PressArticleService {
  async fetchPressArticles({
    limit = PRESS_ARTICLES_LIMIT,
    page = 1,
    category
  }) {
    const skip = (page - 1) * limit;
    const query = Client.items()
      .type(KENTICO_TYPES.PRESS_ARTICLE)
      .orderParameter('elements.data_publikacji', SortOrder.desc)
      .limitParameter(limit)
      .skipParameter(skip);

    if (category) {
      query.equalsFilter('elements.spolka[any]', category.toLowerCase());
    }

    return query.toPromise();
  }
}

export default new PressArticleService();



// WEBPACK FOOTER //
// ./src/services/PressArticle.service.js